import { Component, HostListener, OnInit } from '@angular/core';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { TwoFactorImplementation } from '@mainrepo/app/core/implementation/twoFactorImplementation';
import { PasswordEncryptorUtil } from '@mainrepo/app/core/utils/PasswordEncryptorUtil';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

const regexpEmail = /^([0-9a-zA-Z]*)\s*$/;
// /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{1,50})\.\50)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;

@Component({
  standalone:true,
  selector: 'lib-reset-passpharse',
  templateUrl: './reset-passpharse.component.html',
  styleUrls: ['./reset-passpharse.component.scss'],
  imports:[DependenciesModule]
})
export class ResetPasspharseComponent implements OnInit {

  // public showPassPhraseReset:boolean = false;
  twoFactorImplementation:TwoFactorImplementation
  universalService:any
  localStorageSvc: LocalStorageSvc;
  passwordEncryptorUtil:PasswordEncryptorUtil;
  showError:boolean = false;
  showErrorMess:any;

  public passPhrase;
  public confirmPassPhrase;
  patternCheck:boolean;
  cleverTapEventsService:CleverTapEventsService;
  logincontroller:any
  show: boolean = false;
  getOtpButton:boolean = false
  router: any;

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(this.globalService);
  }
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.close();
    }
  }
  
  async setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    this.logincontroller = UserloginController.getInstance(this.globalService)
    this.router = this.globalService.getRouterRef();
  }

  ngOnInit(): void {
    
    this.cleverTapEventsService.passphraseScreenViewed('Setup passphrase')
    // this.showPassPhraseReset = true;
    this.universalService.showPassPhraseReset = true
    this.showError = false
    this.twoFactorImplementation = TwoFactorImplementation.getInstance(this.globalService);
    this.getOtpButton = false;
    setTimeout(() => {
      document.getElementById("newPassPhrase").focus();
    }, 500);
  }

  async sendOTP(passPhrase,confirmPassPhrase){
    var self = this;

    this.patternCheck = regexpEmail.test(passPhrase) 
    this.showError = false;
    if(passPhrase!=confirmPassPhrase){
      this.showError = true
      this.showErrorMess = "Passphrases entered do not match."
    }else if(!this.patternCheck){
    
    }else if(passPhrase.length<6){
   
    }else{
      this.showError = false
      this.universalService.showLoader = true;
      this.universalService.tempPassPhrase = passPhrase
      let response =  await this.twoFactorImplementation.sendOTP(passPhrase)
      if(response['error']) {
        self.showError = true;
        self.showErrorMess = response['error'].error;
      }
    }
  }

  close(){
    this.showError = false
    this.universalService.showPassPhraseReset = false;
    this.universalService.isPassphraseReset = false
    if(this.universalService.forgotPassPhraseModalOpned){
      this.universalService.show2FApopUp = true;
      this.universalService.forgotPassPhraseModalOpned = false;
    }else{
      this.universalService.disableModalBackdrop()
      if(this.localStorageSvc.getTwoFAEnable(true) == "Y"){
        AppEvents.optionSelected.next({enable2FA: true});
      }else{
        AppEvents.optionSelected.next({enable2FA: false});
      } 
    }
  }

  showHideRestPaasword(id,btnId){
    
    let inputEl = document.getElementById(id) as any ; 
    if (inputEl.type === 'password') {
      inputEl.type="text"
      $('#'+btnId + ' .NeuePassword-Show').addClass('hide');
      $('#'+btnId + ' .NeuePassword-Hide').removeClass('hide');
    } else {
      inputEl.type = 'password';
      $('#'+btnId + ' .NeuePassword-Hide').addClass('hide');
      $('#'+btnId + ' .NeuePassword-Show').removeClass('hide');
    }
  }

  clearError(){
    return false;
  }
  onKeypressEvent(event,passPhrase){
     //   // this.getOtpButton = true;
       // if(passPhrase.length>5 && confirmPassPhrase.length>5 && passPhrase.length == confirmPassPhrase.length ){
       //   this.getOtpButton = false;
       // }
       this.patternCheck = regexpEmail.test(event.keyCode);
       if(passPhrase.length>20 || !((event.keyCode > 64 && event.keyCode < 91) || 
              (event.keyCode > 96 && event.keyCode < 123) || (event.keyCode > 47 && event.keyCode < 58))){
         return false;
       }else{
         return true
       }
      // return (event.keyCode > 64 && event.keyCode < 91) || 
        //       (event.keyCode > 96 && event.keyCode < 123) || (event.keyCode > 47 && event.keyCode < 58)
   
   
   
               //(event.charCode==32)
   
     }

  // onKeyupEvent(event,passPhrase,confirmPassPhrase){
  //   this.getOtpButton = true;
  //   if(passPhrase.length>5 && confirmPassPhrase.length>5 ){
  //     this.getOtpButton = false;
  //   }
  // }

  onKeyupEvent(event,passPhrase,confirmPassPhrase){
    this.getOtpButton = false;
    let updatedPassPharse = passPhrase.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_/\s]/g, '');
    let updatedconfirmPassPhrase = confirmPassPhrase.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_/\s]/g, '');
    if(passPhrase != "") {
      updatedPassPharse = updatedPassPharse.replace(/[^\w\s]/g, '');
    }
    if(confirmPassPhrase != "") {
      updatedconfirmPassPhrase = updatedconfirmPassPhrase.replace(/[^\w\s]/g, '');
    }

    if(passPhrase == "" || confirmPassPhrase == ""){
      return false;
    }
    (<HTMLInputElement>document.getElementById('newPassPhrase')).value = updatedPassPharse;
    (<HTMLInputElement>document.getElementById('confirmPassPhrase')).value = updatedconfirmPassPhrase;
    if(updatedPassPharse.length>=6 && updatedconfirmPassPhrase.length>=6){
      if((updatedPassPharse.length == updatedconfirmPassPhrase.length) && (updatedPassPharse == updatedconfirmPassPhrase) ){
        this.getOtpButton = true;
        this.showErrorMess = ""
        this.showError = false
      }else{
        this.getOtpButton = false;
        this.showErrorMess = "Passphrases entered do not match."
        this.showError = true
      }
    }else{
      this.getOtpButton = false;
      this.showErrorMess = ""
      this.showError = false
    }
    // if(passPhrase.length>5 && confirmPassPhrase.length>5 ){
    //   this.getOtpButton = false;
    // }
  }
  
}
